import React, { FC } from 'react';
import styled from 'styled-components';
import logo from 'images/revizoLogo.svg';

const Container = styled.div`
  user-select: none;
  cursor: pointer;
  height: 50px;
  background: #ffffff;
  opacity: 70%;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  :hover {
    text-decoration: none;
  }
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.1);
`;
const Text = styled.p<{ color: string }>`
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 50px;
  margin: 0;
  color: ${({ color }) => color};
`;

const Image = styled.img`
  width: 70px;
  margin-left: 10px;
`;

export const Copyright: FC<{ color: string }> = ({ color }) => {
  return (
    <Container onClick={() => open('https://revizo.io/ua/')}>
      <Text color={color}>Powered by</Text>
      <Image src={logo} />
    </Container>
  );
};
